import {
  HeaderContainer,
  ScrollableContainer,
  Title,
  CloseIcon,
} from './styled';
import loadable from '@loadable/component';
import type { EventCategory } from '@/constants/events';
import { useVisibleSectionsIsPristine } from '@/pages/CompanyReport/components/VisibleSectionsContextProvider';
import { useSection } from '@/pages/CompanyReport/useSection';
const CompanyFeed = loadable(() => import('@/components/CompanyFeed'), {
  resolveComponent: (component) => component.CompanyFeed,
});

interface Props {
  title: string;
  filter?: EventCategory;
  lookup: string | null;
  onClose?: () => void;
}

export function RecentUpdatesList(props: Props) {
  const { currentSection } = useSection();
  const isPristine = useVisibleSectionsIsPristine();
  // Some complexities around where this is rendered, so we need to check the current section
  const titleElement =
    (currentSection === 'summary' && 'h3') || (isPristine && 'h2') || 'h3';
  const subtitleElement =
    (currentSection === 'summary' && 'h4') || (isPristine && 'h3') || 'h4';
  return (
    <>
      <HeaderContainer data-cy-id="recent-updates">
        <Title as={titleElement}>{props.title}</Title>
        <button data-cy-id="recent-updates-close" onClick={props.onClose}>
          <CloseIcon />
        </button>
      </HeaderContainer>
      <ScrollableContainer>
        <CompanyFeed
          lookup={props.lookup}
          isCompanyReport
          filterByEventCategory={props.filter}
          titleElement={subtitleElement}
        />
      </ScrollableContainer>
    </>
  );
}
